<div class="d-flex" id="wrapper">
  <app-sidebar [collapsed]="isSidebarCollapsed" [class.collapsed]="isSidebarCollapsed" (toggleSidebar)="toggleSidebar()"></app-sidebar>

  <div class="main-content flex-grow-1" [class.collapsed]="isSidebarCollapsed">
    <app-header (toggleSidebar)="toggleSidebar()"></app-header>

    <div class="container-fluid mt-2 p-3 content-area">
      <router-outlet></router-outlet>
    </div>
<app-loader></app-loader>
    <app-footer></app-footer>
  </div>
</div>
